import VueMapbox from "@orienteer/vue-mapbox-ts";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueMapbox, {});
});
